module.exports = __webpack_public_path__ + "img/prof_pic.f1bbefbe.jpg";